import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    drawer_item_container: { paddingHorizontal: 70, flex: 1 },
    full_banner_item_container: { flex: 1, },
    v_body: { flexGrow: 1 }
  },
  {
    [DEVICE_SIZES.XL]: {
      // v_body: { minHeight: 815 },
    },
    [DEVICE_SIZES.LG]: {
      // v_body: { minHeight: 697 },
      drawer_item_container: { paddingHorizontal: 52 },
    },
    [DEVICE_SIZES.MD]: {
      // v_body: { flexGrow: 1 }
      drawer_item_container: { paddingHorizontal: 0 },
    },
    [DEVICE_SIZES.SM]: {
      // v_body: { flexGrow: 1 }
      drawer_item_container: { paddingHorizontal: 0 },
    },
    [DEVICE_SIZES.XS]: {
      // v_body: { flexGrow: 1 }
      drawer_item_container: { paddingHorizontal: 0 },
    },
  }
);

export default useStyles;
